import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FlightDetail from "./FlightDetail";
import LockPriceModal from "./LockPriceModal";
import { AirlineNames } from "../../../helpers/airlineCodes";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import { getLogin } from "../../../features/userSlice";

const FlightList = ({
  val,
  ind,
  pickUp,
  dropOff,
  tripType,
  setModal,
  setShow,
}) => {
  const navigate = useNavigate();
  const [layovers, setLayovers] = useState([]);
  let login = useSelector(getLogin);
  const [isClicked, setIsClicked] = useState(false);

  const { Segments, Fare, IsLcc } = val || {};

  const [showLock, setShowLock] = useState(false);

  React.useEffect(() => {
    if (Object.keys(login).length > 0 && isClicked === true) {
      if (login?.role === "Agent") {
        window.location.reload();
      } else {
        navigate({
          pathname: "/flight-details",
        });
      }
    }
  }, [login, isClicked]);

  const handleFlightBooking = (e) => {
    setIsClicked(true);
    sessionStorage.setItem("flightResultId", JSON.stringify(val.ResultId));
    if (Object.keys(login).length > 0) {
      navigate("/flight-details");
    } else {
      setModal("login");
      setShow(true);
    }
  };

  const Segment = ({
    reverse,
    duration,
    departureTime,
    arrivalTime,
    departureLayovers,
    CabinClass,
  }) => {
    let Departure = reverse ? dropOff : pickUp;
    let Arrival = reverse ? pickUp : dropOff;

    let layovers =
      departureLayovers !== undefined &&
      departureLayovers.filter((ele, ind) => {
        if (departureLayovers?.length > 1 && ind > 0) {
          return ele;
        }
      });

    let Done = [];

    return (
      <>
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="d-flex align-items-center gap-2">
              {departureLayovers?.length > 0 &&
                departureLayovers?.map((ele, ind) => {
                  if (!Done.includes(ele.AirlineDetails.AirlineCode)) {
                    Done.push(ele.AirlineDetails.AirlineCode);
                    return (
                      <div
                        key={ind}
                        className="d-flex justify-content-center align-items-center"
                      >
                        {ind > 0 && ","}
                        <img
                          src={`assets/AirlineLogo/${ele?.AirlineDetails.AirlineCode}.gif`}
                          style={{ height: "35px", width: "35px" }}
                          alt="err"
                        />
                        <h6 className="bold20 ms-2 mb-0">
                          {ele?.AirlineDetails.AirlineName}
                        </h6>
                      </div>
                    );
                  }
                })}
            </div>
          </div>
          <div className="col-lg-5 col-md-3 col-sm-12">
            <div className="flight-listing-inner">
              <p className="medium14">
                {Departure?.citycode} {Departure?.cityname},{" "}
                {Departure?.countryname}
              </p>
              <h5 className="bold24">
                {departureTime?.split("T")[1].split(":")[0]}:
                {departureTime?.split("T")[1].split(":")[1]}
              </h5>
              <span className="medium16">
                {moment(departureLayovers?.[0].DepartureTime).format(
                  `MMMM Do YYYY`
                )}
              </span>

              <p className="medium14" key={ind}>
                {layovers.length > 0 && "Layovers - "}
                {layovers.length > 0 &&
                  layovers.map((ele, ind) => {
                    return (
                      <span key={ind}>
                        {ind > 0 && ","}
                        {ele.Origin.CityName} {ele?.GroundTime?.split(":")[0]}h{" "}
                        {ele?.GroundTime?.split(":")[1]}m
                      </span>
                    );
                  })}
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12">
            <div className="flight-listing-inner">
              {layovers.length > 0 &&
                layovers.map((ele, ind) => {
                  return (
                    <p className="medium14" key={ind}>
                      - {ele.Origin.AirportCode}{" "}
                      {ind === layovers.length - 1 && "-"}
                    </p>
                  );
                })}
              <h5 className="semi16 ml-4">
                {duration?.split(":")[0]}h {duration?.split(":")[1]}m
              </h5>
            </div>
          </div>

          <div className="col-lg-4 col-md-3 col-sm-12">
            <div className="flight-listing-inner">
              <p className="medium14">
                {Arrival?.citycode} {Arrival?.cityname}, {Arrival?.countryname}
              </p>
              <h5 className="bold24">
                {arrivalTime?.split("T")[1].split(":")[0]}:
                {arrivalTime?.split("T")[1].split(":")[1]}
              </h5>

              <span className="medium16">
                {moment(
                  departureLayovers?.[departureLayovers?.length - 1]
                    ?.ArrivalTime
                ).format(`MMMM Do YYYY`)}
              </span>
              {/*  */}
              <div className="flight-listing-main-details">
                <div className="accordion-item border-0">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={reverse ? `#id${ind}rev` : `#id${ind}`}
                      aria-expanded="true"
                      aria-controls="flight-detail3"
                    >
                      Flight Details
                    </button>
                  </h2>
                </div>
              </div>
              {/*  */}
            </div>
          </div>
          <FlightDetail
            val={departureLayovers}
            id={reverse ? `id${ind}rev` : `id${ind}`}
          />
        </div>
      </>
    );
  };
  return (
    <>
      <div
        className={`flight-listing-wrap flight-list-accordion ${
          tripType && "round-trip-flight-listing"
        }`}
      >
        <div className="row align-items-center position-relative">
          {!IsLcc && (
            <span onClick={() => setShowLock(true)}>
              <i className="fa fa-lock px-2"></i>
              Lock The Price
            </span>
          )}

          <LockPriceModal show={showLock} setShow={setShowLock} />

          <div className="col-lg-9 center-border">
            {tripType === "2" ? (
              <>
                <Segment
                  departureTime={Segments[0][0]?.DepartureTime}
                  arrivalTime={Segments[0][Segments[0].length - 1]?.ArrivalTime}
                  duration={
                    Segments[0][Segments[0].length - 1].AccumulatedDuration
                  }
                  departureLayovers={Segments[0]}
                />

                <Segment
                  reverse={true}
                  departureTime={Segments?.[1]?.[0]?.DepartureTime}
                  arrivalTime={
                    Segments?.[1]?.[Segments?.[1]?.length - 1]?.ArrivalTime
                  }
                  duration={
                    Segments?.[1]?.[Segments?.[1]?.length - 1]
                      .AccumulatedDuration
                  }
                  departureLayovers={Segments?.[1]}
                />
              </>
            ) : (
              <Segment
                departureTime={Segments[0][0]?.DepartureTime}
                arrivalTime={Segments[0][Segments[0].length - 1]?.ArrivalTime}
                duration={
                  Segments[0][Segments[0].length - 1].AccumulatedDuration
                }
                departureLayovers={Segments[0]}
              />
            )}
          </div>

          <div className="col-lg-3 col-md-3 col-sm-12">
            <div className="flight-listing-inner">
              <div className="total-availabity" style={{ top: "0" }}>
                <h3>
                  <img className="seat-img" src="./assets/images/seat.svg" />
                  <span className="seats-available">
                    {Segments[0]?.[0]?.NoOfSeatAvailable}
                  </span>
                </h3>
                <h3 className="cabinclass">{Segments[0]?.[0]?.CabinClass}</h3>
                <h2>
                  <i className="fas fa-dollar-sign"></i>{" "}
                  {parseFloat(Fare.TotalFare).toFixed(2)}
                </h2>
                <button onClick={handleFlightBooking} className="cmn-btn">
                  Book
                </button>
              </div>
            </div>
          </div>
          {/*  */}
        </div>
      </div>
    </>
  );
};

export default FlightList;
